<template>
  <div id="app">
    <div class="header">
      <!-- <button
        class="btn btn__simple"
        :class="{ btn__hidden: !previousRoute }"
        @click="goToPreviousRoute"
      >
        <small class="text-primary">
          <i class="fas fa-chevron-left"></i>
          <span class="hide-mobile">Vorige</span>
        </small>
      </button> -->
      <img
        class="logo"
        src="@/assets/images/xxl_cargo_final_logo.png"
        alt="Logylist"
      />
      <span class="tagline">Partner van Meubeltrein</span>
      <button @click="closeFlow" class="btn btn__simple">
        <small class>
          <i class="fas fa-times"></i>
          <span class="hide-mobile">Annuleren</span>
        </small>
      </button>
    </div>

    <div class="status__bar"></div>
    <div class="__spacer"></div>
    <div class="content">
      <div class="steps">
        <div class="steps__wrapper">
          <transition :name="transitionName">
            <router-view />
          </transition>
        </div>
      </div>
      <div class="side__bar" :class="{ show: showModal }">
        <Sidebar ref="sidebar" />
      </div>
      <div class="side__bar-mobile">
        <p>
          <b>Uw verzendkosten : </b>
          <span
            v-if="typeTransport !== 'verhuizing' && $refs.sidebar && totalPrice"
          >
            € {{ totalPrice.toFixed(2) }},-</span
          >
          <span
            v-if="
              typeTransport === 'verhuizing' &&
                $refs.sidebar &&
                totalPriceVerhuizing
            "
          >
            € {{ totalPriceVerhuizing.toFixed(2) }},-</span
          >
        </p>
        <button
          @click="toggleModal"
          class="btn btn__bordered fit-content ml-auto"
        >
          <span v-if="showModal">Sluiten</span>
          <span v-else><strong>Uw zending</strong></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";
import { mapFields } from "vuex-map-fields";

export default {
  name: "app",
  components: {
    Sidebar
  },
  data() {
    return {
      showModal: false
    };
  },
  mounted() {
    this.setAllRoutes();

    // setTimeout(() => {
    //   let type = this.typeTransport;
    //   if (type === "verhuizing") {
    //     this.routes = this.$router.options.routes
    //       .map(item => {
    //         if (["both", "moving"].indexOf(item.type) !== -1) {
    //           return item.name;
    //         }
    //       })
    //       .filter(item => typeof item === "string");
    //   } else {
    //     this.routes = this.$router.options.routes
    //       .map(item => {
    //         if (["both", "service"].indexOf(item.type) !== -1) {
    //           return item.name;
    //         }
    //       })
    //       .filter(item => typeof item === "string");
    //   }
    // }, 250)
  },
  computed: {
    ...mapFields(["transitionName", "typeTransport", "zelfdedag"]),
    totalPrice() {
      return this.$refs.sidebar.totalPrice;
    },
    totalPriceVerhuizing() {
      return this.$refs.sidebar.totalPriceVerhuizing;
    }
  },
  methods: {
    closeFlow() {
      window.sessionStorage.removeItem("vuex");
      location.href = "https://xxlcargo.nl";
    },
    toggleModal() {
      this.showModal = !this.showModal;
      if (this.showModal) {
        document.querySelector("body").classList.add("hide-scroll");
      } else {
        document.querySelector("body").classList.remove("hide-scroll");
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Dosis:wght@300;500;700&display=swap");
:root {
  --light-grey: #e6e6e6;
  --black: #000000;
  --white: #ffffff;
  --yellow: #ffcd00;
  --orange: #f1592a;
  --orange-darker: #a73917;
  --status-bar: rgba(0, 0, 0, 0.05);
  --grey: rgba(112, 112, 112, 0.5);
}

html,
body {
  margin: 0;
  padding: 0;
  font-family: "Dosis", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

html {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: inherit;
  -moz-box-sizing: inherit;
  box-sizing: inherit;
}

.hide-scroll {
  overflow-y: hidden;
}

.w-100 {
  width: 100%;
}
.margintop_0 {
  margin-top: 0px !important;
}
.bijnaText { font-size: 18px; font-weight: bold; color: var(--orange);margin-bottom: 20px; }
.termsText label { font-weight: normal !important;font-size: 16px !important; }

.hide-mobile {
  @media only screen and (max-width: 540px) {
    display: none;
  }
}

small > .fa-times {
  @media only screen and (min-width: 541px) {
    display: none;
  }
}

.status {
  &__bar {
    width: 100%;
    height: 5px;
    background-color: var(--status-bar);
  }
}

.btn {
  box-shadow: none;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 300ms ease-in-out;
  font-family: "Dosis", sans-serif;
  outline: none;
  border-radius: 5px;

  &[disabled="disabled"],
  &:disabled {
    opacity: 0.2;
  }

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &__hidden {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
  }

  &__simple {
    color: var(--grey);
    text-decoration: none;
    font-weight: 400;
    font-size: 20px;
  }

  &__bordered {
    height: 45px;
    font-weight: bold;
    color: var(--orange);
    border: 1px solid var(--orange);
    border-radius: 5px;
    font-size: 14px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    letter-spacing: 1px;
  }

  &__filled {
    background-color: var(--orange);
    border-radius: 10px;
    font-weight: 700;
    font-size: 19px;
    border: 1px solid var(--orange);
    border-bottom: 3px solid var(--orange-darker);
    max-width: 300px;
    float: right;
    height: 60px;
    color: var(--white);

    &-grey {
      background-color: var(--light-grey);
      border: 1px solid var(--light-grey);
    }
  }
  &__offraan {
    background-color: transparent;
    color: var(--orange);
    border: 1px solid var(--orange);
    border-bottom: 3px solid var(--orange-darker);
  }
  &__left {
    float: left;
  }
  &__backbt {
    color: var(--orange);
    margin-top: 30px;
    .fas {
      color: var(--orange) !important;
    }
  }
  @media only screen and (max-width: 890px) {
    &__filled {
      float: none;
      max-width: initial;
      margin-bottom: 15px;
    }
    &__backbt {
      display: block;
      text-align: center;
      float: none;
      margin: 0px auto 0 auto;
    }
    &__addObj {
      float: none;
      max-width: initial;
      margin-bottom: 15px;
      display: block;
      width: 100%;
    }
  }
}

.logo {
  margin: 10px 0;
  max-width: 180px;

  @media only screen and (max-width: 540px) {
    max-width: 130px;
  }
}
.header button {
  text-decoration: none;
  font-weight: 400;
  font-size: 20px;
  float: right;
  padding: 20px;
  color: var(--orange);
  margin-top: 9px;
  @media only screen and (max-width: 540px) {
    padding: 8px 0px 8px 20px;
    margin-top: 0px;
  }
}
.header .tagline {
  text-decoration: none;
  font-weight: 400;
  font-size: 13px;
  padding: 0px 20px;
  color: var(--white);
  margin-top: 0px;
  position: absolute;
  top: 50%;

  @media only screen and (max-width: 540px) {
    top: 69%;
    left: 30px;
    font-size: 13px;
  }
}
.header img {
  padding-left: 20px;
  margin-left: 20px;
}

.header {
  position: fixed;
  width: 100%;
  background-color: var(--black);
  border-bottom: 2px solid var(--orange);
  z-index: 9;
  height: 90px;

  @media only screen and (max-width: 540px) {
    padding: 0 20px;
    width: 100%;
    i {
      font-size: 18px !important;
      line-height: 70px;
    }
  }
}
.__spacer {
  margin-top: 70px;
}
.form-group label {
  line-height: 35px;
}
h1,
.h1 {
  font-size: 30px;
  line-height: 40px;
  margin-bottom: 35px;
  margin-top: 0;
}
.h1,
.h2,
h1 {
  font-weight: 700;
  margin-top: 0;
  letter-spacing: -0.02em;
}

.h2 {
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 5px;
  margin-top: 0;
  letter-spacing: -0.02em;
  color: var(--orange);
  @media only screen and (max-width: 540px) {
    font-size: 20px;
  }
}
.card {
  border-radius: 8px;
  background-color: #fff;
}
h3,
.h3 {
  font-size: 19px;
  line-height: 30px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 0;
  letter-spacing: -0.02em;
  .fas {
    font-size: 18px;
    margin-right: 8px;
    color: var(--orange);
  }
}
.text-light {
  font-weight: 300;
  color: var(--orange);
}
p {
  font-size: 16px;
  font-weight: 400px;
  line-height: 20px;
}

.step {
  padding: 0;
}

.content {
  display: grid;
  grid-template-columns: 7fr 3fr;
  height: 100%;
  min-height: calc(100vh - 75px);
  background-color: #f3f3f3;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 6fr 4fr;
  }

  @media only screen and (min-width: 1200px) {
    padding-bottom: 55px;
  }

  @media only screen and (max-width: 890px) {
    grid-template-columns: 1fr;
    width: 100%;
    display: block;
    box-sizing: border-box;
  }
}
.row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 15px;
  margin-bottom: 5px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}
.steps {
  max-width: 991px;
  width: 100%;
  margin: 0px auto;
  padding: 35px 20px;
  box-sizing: border-box;

  &__wrapper {
    position: relative;

    @media only screen and (max-width: 890px) {
      padding-bottom: 70px;
    }
  }
}
.form-group {
  margin-top: 5px;

  @media only screen and (max-width: 890px) {
    display: block;
    box-sizing: border-box;
  }
}

.row-1,
.row-2,
.row-3 {
  @media only screen and (max-width: 890px) {
    display: block !important;
    box-sizing: border-box;
  }
}
.card__option .text-light,
.card__option .h2 {
  color: #333 !important;
}
.card__option.active,
.card__option {
  border-left-width: 5px;
  border-radius: 8px;
  background-color: var(--white);
}
.card__option.active {
  border-left-color: var(--orange);
}
.card__option.active .text-light,
.card__option.active .h2 {
  color: var(--orange) !important;
}

.side__bar {
  background-color: #f2d6cd;

  &-mobile {
    background-color: var(--orange);
    position: fixed;
    height: 60px;
    bottom: 0;
    right: 0;
    left: 0;
    display: grid;
    grid-template-columns: 6fr 4fr;
    padding: 0 20px;
    display: flex;
    align-items: center;
    color: var(--white);

    .btn {
      font-weight: bold;
      color: var(--white);
      border: 1px solid var(--white);
      font-size: 15px;
    }

    @media only screen and (min-width: 891px) {
      display: none;
    }
  }

  @media only screen and (max-width: 890px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: calc(100vh - 80px - 60px);
    padding-top: 80px;
    padding-bottom: 80px;
    display: none;
    overflow-y: scroll;

    .h1 {
      font-size: 20px !important;
      margin-bottom: 5px !important;
    }

    .sidebar {
      padding: 20px;
    }

    .h3 {
      font-size: 16px;
    }

    .price-row {
      margin-bottom: 5px;
    }

    &.show {
      display: flex;
    }
  }
}
@media only screen and (max-width: 540px) {
  .subtotalRow .price-content { margin-left: 38px !important; }
  .totalRow {margin-left: 38px !important;}
}
.form-group select,
.form-group input,
.form-group textarea {
  border: 1px solid #cecece !important;
  font-size: 18px !important;
  font-weight: 300;
  font-family: "Dosis", sans-serif;
}
.form-group option {
  font-weight: normal;
  display: block;
  white-space: pre;
  min-height: 1.2em;
  padding: 10px 2px 10px 5px;
}
.form-group {
  display: flex;
  flex-direction: column;

  label {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 5px;
  }

  select,
  input,
  textarea {
    max-width: 100%;
    border-radius: 6px;
    border: 1px solid var(--black);
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 300px;
    padding: 0 12px;

    &:focus,
    &:active {
      outline: none;
    }
  }

  input {
    display: flex;
    flex: 1;
    max-height: 45px;
  }

  input[type="checkbox"] {
    display: block;
    flex: none;
  }

  textarea {
    height: auto;
    min-height: 90px;
  }

  &.form-error {
    input {
      border-color: #f5c6cb !important;
    }
    label {
      color: red;
    }
  }
}

.error {
  color: #721c24;
  background-color: #f8d7da;
  border-radius: 5px;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid #f5c6cb;
}
.info {
  color: #333;
  background-color: #f2d6cd;
  border-radius: 5px;
  padding: 0rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid #f2d6cd;
  margin-top: 15px;

  &-padding {
    padding: 0.75rem 1.25rem;
  }
}
.next-enter-active,
.next-leave-active,
.previous-enter-active,
.previous-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
  position: absolute;
  width: 100%;
}

.next-enter,
.previous-leave-active {
  opacity: 0;
  transform: translateX(100px);
}

.next-leave-active,
.previous-enter {
  opacity: 0;
  transform: translateX(-100px);
}

.input-group {
  display: flex;
}

.vbt-autcomplete-list {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  background: #fff;
  padding: 0 !important;

  a {
    display: flex;
    flex: 1;
    padding: 8px 20px;
    color: var(--black);
    text-decoration: none;

    &:hover,
    &:focus,
    &:active {
      background: rgba(0, 0, 0, 0.12);
    }
  }
}
hr {
  border: 1px solid #efefef;
  margin: 10px 0px 20px 0px;
}
.step-icon {
  font-size: 20px;
  color: var(--orange);
  margin-right: 15px;
}
.status__bar {
  width: 100%;
  height: 5px;
  background-color: rgb(255, 205, 0);
}
small {
  font-size: 80%;
}

.text-primary {
  color: var(--orange);
}
.btn__simple .fas {
  font-size: 12px;
  margin-right: 10px;
  color: #cecece;
}

.fit-content {
  width: fit-content;
}

.ml-auto {
  margin-left: auto;
}
@media only screen and (min-width: 1200px) {
  .footer-app {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .footer-app .sub-footer {
    background: #fff;
    font-size: 15px;
    color: #333;
    padding: 3px 0;
    text-align: right;
    height: 65px;
  }
  .transportlanden {
    float: left;
  }

  .footer-app .list-inline > li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 0px;
  }
  .transportlanden img.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 20px;
    border: 1px solid #515d69;
  }
  .footer-app .list-inline > li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 0px;
  }
  .betalen-img img {
    margin-right: 30px;
    margin-top: -5px;
  }
}
@media only screen and (max-width: 1199px) {
  .transportlanden {
    list-style: none;
  }
  .transportlanden li:first-child {
    display: inline-block;
  }
  .transportlanden li:first-child img {
    width: 40px;
    border: 1px solid #515d69;
  }
  .transportlanden li:nth-child(2) {
    display: inline-block;
    padding-left: 10px;
  }
  .transportlanden li:nth-child(2) img {
    width: 40px;
    border: 1px solid #515d69;
  }
  .betalen-img {
    list-style: none;
  }
}
@media only screen and (max-width: 890px) {
  .footer-app .sub-footer {
    display: none;
  }
}
</style>
